// @ftedn/shared — API surface prefixes

export const CREATOR_API_PREFIX = '/api/creator';
export const TEAM_API_PREFIX = '/api/team';
